import React, { FC, useMemo } from 'react';
import { useBidding, useTasksFilter } from 'src/models/bids/BidFull/hooks';
import BidSidebar from '../BidSidebar';
import TasksFilter from '../TasksFilter';
import TasksStatistic from '../TasksStatistic';
import TasksHeading from '../TasksHeading';
import { BidChecklist } from 'src/shared';
import styles from './index.module.scss';
import { GroupExpandProvider } from 'src/models/bids/BidFull/providers';
import { isTasksFilterApplied } from 'src/models/bids/BidFull/helpers';
import { EmptyFilter, Skeleton } from 'src/common';
import { useTranslation } from 'react-i18next';
import TasksGroup from '../TaskGroup';

export const BiddingContent: FC = () => {
  const { t } = useTranslation();
  const { filter } = useTasksFilter();
  const { data, loading } = useBidding();
  const groups = data?.questionGroups;
  const bidId = data?.id;

  const isAllGroupsEmpty = useMemo(() => groups?.every(group => group.totalTasks === 0), [groups]);
  const isFilterApplied = useMemo(() => isTasksFilterApplied(filter), [filter]);

  return (
    <>
      <TasksStatistic />
      <TasksHeading />
      <TasksFilter />
      {loading ? (
        <Skeleton active={loading} />
      ) : isAllGroupsEmpty && isFilterApplied ? (
        <EmptyFilter title={t('BiddingTool.Filters.noMatch')} desc={t('BiddingTool.Filters.noMatchDesc')} />
      ) : (
        !!groups?.length && (
          <section className={styles.groups}>
            {bidId &&
              !!groups.length &&
              groups.map(group =>
                !!group.totalTasks || !isFilterApplied ? (
                  <GroupExpandProvider key={group.id} isExpanded={false}>
                    <TasksGroup groupId={group.id} />
                  </GroupExpandProvider>
                ) : null
              )}
          </section>
        )
      )}
      <BidSidebar />
      <BidChecklist bidId={data?.id ?? ''} />
    </>
  );
};

export default BiddingContent;
